import * as yup from "yup";

export const oxygenRetailSchema1 = yup.object().shape({
  bank: yup
    .string()
    .required("Bank selection is required"),
  
  accountNumber: yup
    .string()
    .matches(/^\d{10}$/, "Account Number must be 10 digits")
    .required("Account Number is required"),

  bvn: yup
    .string()
    .matches(/^\d{11}$/, "BVN must be 11 digits")
    .required("BVN is required"),

  employmentStatus: yup.string().required("Employment status is required"),

  email: yup.string().email("Invalid email format").required("Email is required"),
});


export const oxygenRetailSchema2 = (employmentStatus) => {
  const isUnemployed = employmentStatus === "UNEMPLOYED";
  // const isSelfEmployed = employmentStatus === "SELF_EMPLOYED";
  const isEmployed = employmentStatus === "EMPLOYED";

  return yup.object().shape({
    nin: yup
      .string()
      .trim()
      .required("NIN is required")
      .matches(/^\d+$/, "NIN must contain only digits")
      .length(11, "NIN must be exactly 11 digits"),

    nameOfEmployer: yup
      .string()
      .trim()
      .test(
        "required-based-on-status",
        "Name of employer is required",
        (value) => {
          if (!isUnemployed && !value) return false;
          return true;
        }
      )
      .nullable(),

    salaryAmount: yup
      .number()
      .typeError("Salary amount must be a number")
      .test("required-if-employed", "Salary amount is required", (value) => {
        if (isEmployed && (value === undefined || value === null || value === ""))
          return false;
        return true;
      })
      .positive("Salary must be greater than 0")
      .nullable(),

    salaryDay: yup
      .number()
      .typeError("Salary day must be a number")
      .test("required-if-employed", "Salary day is required", (value) => {
        if (isEmployed && (value === undefined || value === null || value === ""))
          return false;
        return true;
      })
      .integer("Salary day must be an integer")
      .min(1, "Salary day must be between 1 and 31")
      .max(31, "Salary day must be between 1 and 31")
      .nullable(),
  });
};


export const oxygenRetailSchema = yup.object().shape({
  bank: yup
    .string()
    .required("Bank selection is required"),
  
  accountNumber: yup
    .string()
    .matches(/^\d{10}$/, "Account Number must be 10 digits")
    .required("Account Number is required"),

  // accountName: yup.string().required("Account Name is required"),

  bvn: yup
    .string()
    .matches(/^\d{11}$/, "BVN must be 11 digits")
    .required("BVN is required"),

  nin: yup
    .string()
    .matches(/^\d{11}$/, "NIN must be 11 digits")
    .required("NIN is required"),

  msisdn: yup
    .string() 
    .matches(/^\d{11}$/, "Phone Number must be 11 digits")
    .required("Phone Number is required"),

  employmentStatus: yup.string().required("Employment status is required"),

  email: yup.string().email("Invalid email format").required("Email is required"),
});

export const oxygenFormOTPSchema = yup.object().shape({
  otpValue: yup.string().required("OTP is required"),
});

export const oxygenScreenSchema = yup.object().shape({
  msisdn: yup
    .string() 
    .matches(/^\d{11}$/, "Phone Number must be 11 digits")
    .required("Phone Number is required"),
});

export const AODF2ScreenSchema = yup.object().shape({
  msisdn: yup
    .string() 
    .matches(/^\d{11}$/, "Phone Number must be 11 digits")
    .required("Phone Number is required"),
  
  nin: yup
    .string()
    .matches(/^\d{11}$/, "NIN must be 11 digits")
    .required("NIN is required"),
    
});


export const fbnPrequalFormSchema = yup.object().shape({
  telco: yup
    .string()
    .required("Telco selection is required"),
  partnerid: yup
    .string()
    .required("Partner selection is required"),
  bvn: yup
    .string()
    .matches(/^\d{10}$/, "Account Number must be 10 digits")
    .required("Account Number is required"),

  nin: yup
    .string()
    .matches(/^\d{11}$/, "NIN must be 11 digits")
    .required("NIN is required"),

  msisdn: yup
    .string() 
    .matches(/^\d{11}$/, "Phone Number must be 11 digits")
    .required("Phone Number is required"),

  email: yup.string().email("Invalid email format").required("Email is required"),
});